import { createAction } from '@reduxjs/toolkit';

import type { AIAvatar, AIAvatarVoicePreset } from 'js/src/client';
import { ACTIONS } from 'js/src/data/ai-voices-and-avatars/ai-voices-and-avatars-types';

export const setAIAvatarVoicePresets = createAction<Array<AIAvatarVoicePreset>>(
    ACTIONS.SET_AI_AVATAR_VOICE_PRESETS,
);

export const setAIAvatars = createAction<Array<AIAvatar>>(ACTIONS.SET_AI_AVATARS);

export const setAIVoiceoverBatchComplete = createAction<boolean>(
    ACTIONS.SET_AI_VOICEOVER_BATCH_COMPLETE,
);
